import { useLocation, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
export default function Vierappointment() {
  const location = useLocation();
  const personalinfo = location?.state?.data;
  const navigate = useNavigate();
  return (
    <div className="pc-container">
      <div className="pc-content">
        <div>
          <div className="row">
            <div className="col-md-12">
              <div
                className=" card table-card  mb-3"
                style={{ position: "relative" }}
              >
                <div>
                  <div className="tableHeader">
                    <div className="d-flex">
                      <button
                        className="backArrow"
                        onClick={() => navigate(-1)}
                      >
                        <i className="fa fa-arrow-left"></i>
                      </button>
                      <h5 className="mb-0">View Appointment</h5>
                    </div>
                  </div>
                  <div className="row p20">
                    <div className="col-md-6">
                      <label className="form-label">Doctor Name</label>
                      <input
                        type="text"
                        className="form-control"
                        value={personalinfo?.displayName}
                        placeholder="File Number"
                        disabled
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Patient Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Name"
                        disabled
                        value={personalinfo?.patientName}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Start Time</label>
                      <input
                        type="text"
                        disabled
                        value={
                          personalinfo?.startTime
                            ? dayjs(`2023-01-01T${personalinfo.startTime}`).format("hh:mm A")
                            : ""
                        }
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">End Time</label>
                      <input
                        type="text"
                        disabled
                        value={
                          personalinfo?.endTime
                            ? dayjs(`2023-01-01T${personalinfo.endTime}`).format("hh:mm A")
                            : ""
                        }
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Date</label>
                      <input
                        type="date"
                        disabled
                        className="form-control"
                        value={
                          personalinfo?.appointmentDate
                            ? personalinfo.appointmentDate.split(" ")[0]
                            : ""
                        }
                      />

                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Status</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Civil ID"
                        disabled
                        value={personalinfo?.status}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4 rightSidePer"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
